import { useQuery } from '@tanstack/react-query';

import { checkIsUserAssociatedWithAnyOrganization } from '@/infrastructure/network/data/permissions/permissions';

export const useCheckIsUserAssociatedWithAnyOrgQuery = ({ isEnabled }: { isEnabled: boolean }) => {
	return useQuery({
		queryKey: ['CHECK_IS_USER_ASSOCIATED_WITH_ANY_ORG'],
		queryFn: () => checkIsUserAssociatedWithAnyOrganization(),
		enabled: isEnabled
	});
};
